/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Period defaults
 */
export type ILevel = "year" | "quarter" | "4-years";
export const FIRST_DATA_YEAR = 2010;

/** Last closed reporting month: e.g. in April → "3 / YYYY" (March). */
export const getDefaultMonthYearPeriodFromToday = (): string => {
  const ref = new Date();
  ref.setDate(1);
  ref.setMonth(ref.getMonth() - 1);
  return `${ref.getMonth() + 1} / ${ref.getFullYear()}`;
};

export const getDefaultPeriod = (model?: string) => {
  const currentYear = new Date().getFullYear();
  if (model === "DP2021") {
    let y = currentYear - 1;
    if (y < FIRST_DATA_YEAR) {
      y = FIRST_DATA_YEAR;
    }
    return `Q4 / ${y}`;
  }
  // Monthly scorecards: default to previous calendar month (not current).
  return getDefaultMonthYearPeriodFromToday();
};
export function getYearPeriod(period: string) {
  const convertToYear = (period: string, dec = 0) => {
    let year = parseInt(period.split("/")[1], 10) - dec;
    if (year < FIRST_DATA_YEAR) {
      year = FIRST_DATA_YEAR;
    }
    return year ? year.toString() : "";
  };
  const updatedPeriod = period.toUpperCase().replace(/\s/g, "");
  switch (true) {
    case updatedPeriod.includes("Q1"):
    case updatedPeriod.includes("Q2"):
    case updatedPeriod.includes("Q3"):
      return convertToYear(updatedPeriod, 1) || period;
    case updatedPeriod.includes("Q4"):
      return convertToYear(updatedPeriod) || period;
    default:
      return period;
  }
}
export function getDisplayPeriod(level: ILevel, period = "") {
  if (!period) return period;
  switch (level) {
    case "year":
      return getYearPeriod(period);
    default:
      return period;
  }
}
